import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IItemState } from './item.types';
import { IItemData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IItemState = {
  version: 1,
  count: 0,
  items: [] as IItemData[]
};

const namespaced = true;

export const item: Module<IItemState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
